import logo from '../../../assets/images/svg/logo-white.svg';

export const Footer = () => {
	const logoClickHandler = () => {
		window.open('https://healthbegins.org/', '_blank');
	};

	return (
		<footer className='w-full bg-primary text-white box-border'>
			<div className='h-[0.4rem] w-full bg-secondary'></div>
			<div className='flex flex-col gap-[2.4rem] px-[5rem] py-[4rem]'>
				<img
					src={logo}
					alt='HealthBegins'
					className='w-[22rem] h-[7.4rem] cursor-pointer'
					onClick={logoClickHandler}
				/>
				<div className='border-t border-primary-400/40 pt-[2rem] font-colfax text-[1.3rem] text-primary-100'>
					© HealthBegins &middot; The Return on Investment (ROI) Calculator for
					Healthcare Partnerships to Address Social Needs
				</div>
			</div>
		</footer>
	);
};
